import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {SubscriptionLike} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {ProductoService} from '../../../servicios/producto/producto.service';
import {Login} from '../../../modelo/usuario/login';
import {UserloginService} from '../../../servicios/usuario/userlogin.service';
import {Producto} from '../../../modelo/producto/producto';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {CarMarcaService} from "../../../servicios/soporte/car-marca.service";
import {CarMarca} from "../../../modelo/soporte/car-marca";
import {MatDialog} from "@angular/material/dialog";
import {
  MarcaDescripcionEmergenteComponent
} from "../../../ui/modals/marca-descripcion-emergente/marca-descripcion-emergente.component";

@Component({
  selector: 'app-productos-list',
  templateUrl: './productos-list.component.html',
  styleUrls: ['./productos-list.component.css']
})
export class ProductosListComponent implements OnInit, OnDestroy {

  public currentUser: Login;
  private subs: SubscriptionLike[];
  public productos: Producto[];

  public paginaActual = 0;
  public cantXPagina = 50;
  public cantidadPaginas = 0;
  public totalItems=0;
  public idUsuario:number=0;
  pageEvent: PageEvent;
  private t: string;
  private l: string;
  private r: string;
  private f: string;
  private busc: string;
  private marc: string;
  public clicodigo: string;
  public onlyMarca:boolean=false;
  public sow:boolean=false;
  public carMarca:CarMarca;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(private userLogin: UserloginService, private routerAc: ActivatedRoute, private prodSV: ProductoService,private carMarcaSV:CarMarcaService, public dialog: MatDialog,) {
    this.currentUser = null;
    this.subs = [];
    this.productos = [];
    this.pageEvent = new PageEvent();
    this.carMarca = null;
  }

  ngOnInit(): void {
    this.paginator._intl.itemsPerPageLabel = 'Productos por pagina: ';
    this.paginator._intl.firstPageLabel = 'Primera página';
    this.paginator._intl.lastPageLabel = 'Ultima página';
    this.paginator._intl.nextPageLabel = 'Página siguiente';
    this.paginator._intl.previousPageLabel = 'Página anterior';
    this.subs.push(
    this.userLogin.currentUser.subscribe(res=>{
      this.currentUser = res;
      this.clicodigo = this.currentUser != null ? this.currentUser.cliCodigo : '0';
      this.idUsuario = this.currentUser != null ? parseInt(this.currentUser.idUsuario) : 0;
      this.subs.push(
        this.routerAc.queryParams.subscribe(parm => {
          this.paginator.pageSize=this.cantXPagina;
          this.t = parm.T != undefined ? parm.T : '';
          this.l = parm.L != undefined ? parm.L : '';
          this.r = parm.R != undefined ? parm.R : '';
          this.f = parm.F != undefined ? parm.F : '';
          this.busc = parm.B != undefined ? parm.B : '';
          this.marc = parm.marca != undefined ? parm.marca : '';
          if(this.t==''&&this.busc==''&&this.marc!=''){
            this.onlyMarca=true;
          }
          this.subs.push(
            this.prodSV.traerProductos(this.t, this.l, this.r, this.f, this.busc, this.marc, this.clicodigo, this.paginaActual, this.cantXPagina).subscribe(res => {
              this.productos = res.data.productos;
              this.totalItems = res.data.totalItems;
              this.cantidadPaginas = res.data.cantPaginas;
            })
          );
          if (this.onlyMarca) {
           this.subs.push(
            this.carMarcaSV.traerMarca(this.marc).subscribe(res => {
                this.carMarca=res.data;
                this.abrirModalDescripcion();
            }));
          }
        })
      );
    }));
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

  getServerData($event: PageEvent) {
    this.cantidadPaginas=$event.pageSize;
    this.subs.push(
    this.prodSV.traerProductos(this.t, this.l, this.r, this.f, this.busc, this.marc, this.clicodigo, $event.pageIndex, $event.pageSize).subscribe(res => {
        this.productos = res.data.productos;
      }
    ));
    return $event;
  }
  abrirModalDescripcion(){
    if(this.carMarca.descripcion_publicidad!=undefined && this.carMarca.descripcion_publicidad.length>0){
      this.dialog.open(MarcaDescripcionEmergenteComponent, {
        data: this.carMarca.descripcion_publicidad,
        panelClass: 'dialog-marca-descripcion',
        hasBackdrop: false,
        position: {
          bottom:'150px'
        }
      });
    }
  }

}
